import { TriangleAlert } from "lucide-react";
import { Box, Paper, Stack, Typography, useTheme } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";
import { useEffect } from "react";

export default function InvalidPortalUrl() {
    const theme = useTheme();

    useEffect(() => {
        document.title = "Invalid URL - Client Bookings Zanda";
    }, []);

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            p={2}
            data-test-id="section_invalid_portal_url"
        >
            <Paper elevation={4} sx={{ width: "600px" }}>
                <Stack spacing={3} p={4} alignItems="center">
                    <TriangleAlert
                        size={28}
                        strokeWidth={2}
                        color={theme.palette.primary.main}
                        data-test-id="icon_error"
                        aria-hidden
                    />
                    <Box display="flex" flexDirection="column" gap={1}>
                        <Typography variant="heading3" textAlign="center" data-test-id="text_error_title">
                            This Client Portal URL is invalid
                        </Typography>
                        <Typography
                            variant="paragraphMediumRegular"
                            textAlign="center"
                            data-test-id="text_error_subtitle"
                        >
                            Please check the URL and try again.
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            background: palette.neutral[50],
                            borderRadius: 1,
                            padding: 2,
                        }}
                        data-test-id="section_error_instructions"
                    >
                        <Typography variant="paragraphMediumBold" data-test-id="text_instructions_title">
                            What can you do?
                        </Typography>
                        <ul style={{ margin: 0 }}>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_check">
                                    Double-check the link you were given by your practice.
                                </Typography>
                            </li>
                            <li>
                                <Typography variant="paragraphMediumRegular" data-test-id="text_instruction_contact">
                                    If you&apos;re still having trouble, contact your practice directly for help.
                                </Typography>
                            </li>
                        </ul>
                    </Box>
                </Stack>
            </Paper>
        </Box>
    );
}
